import React from "react";
import styled from "styled-components";
import { path } from "ramda";
import StoreButtons from "../common/StoreButtons";
import lockSVG from "../../../images/lock-red.svg";
import messageSVG from "../../../images/message-square.png";
import thumbSVG from "../../../images/thumbs-down.png";
import BuyForm from "../common/Checkout/BuyForm";

const UnlockTopNineInfo = ({
  user,
  userName,
  userEmail,
  loading,
  price,
  buttonText,
  updateTopNineOrder,
  setStatus,
  refreshCurrentUser,
  error,
  ...props
}) => (
  <InfoContainer>
    <ItemsContainer>
      <Item>
        <Icon src={lockSVG} withMarginTop={true} />
        <ItemContainer>
          <Title>Secure Payment</Title>
          <Text>
            Your payment is secured and processed by Stripe.com. We do not store your payment information.
          </Text>
        </ItemContainer>
      </Item>
      <Item>
        <Icon src={messageSVG} />
        <ItemContainer>
          <Title>Instant support</Title>
          <Text>
            We provide instant email support to each of our paid users. You can expect to hear from us minutes
            after you reach to support@topnine.co (not .com!)
          </Text>
        </ItemContainer>
      </Item>
      <Item>
        <Icon src={thumbSVG} />
        <ItemContainer>
          <Title>Support us!</Title>
          <Text>
            Your payment helps us maintain and improve Top Nine. From all of us here working on Top Nine: THANK
            YOU!
          </Text>
        </ItemContainer>
      </Item>
    </ItemsContainer>

    <Item style={{ marginBottom: 0 }}>
      <ItemContainer style={{ marginLeft: 0 }}>
        <Title>Download our app!</Title>
        <Text>
          No one wants another app on their phone, but this one comes with surprises we promise you’ll love!
        </Text>
        <DownloadBullets>
          <DownloadBullet>More grid customizations</DownloadBullet>
          <DownloadBullet>More story/video templates</DownloadBullet>
          <DownloadBullet>Easier to share on Instagram!</DownloadBullet>
        </DownloadBullets>
      </ItemContainer>
    </Item>
    <StoreButtons style={{ marginBottom: "26px", marginTop: 10 }} />

    <CheckoutText>
      Please checkout to continue. <br />
      <strong>
        {`You will receive the Top Nine ${props.videoSupportUs ? "video" : "image"} for`}
        <b> @{userName}</b> to <b>{userEmail ? userEmail : ""}</b> seconds after your purchase.
      </strong>
    </CheckoutText>
    <LastText>
      We've created Top Nine to help you reflect and rediscover your Top Nine Instagram moments of 2020. We hope
      you had an amazing 2020 and we wish you the best for this upcoming year!
    </LastText>
    <BuyForm
      error={error}
      price={price}
      buttonText={buttonText}
      onTokenSuccess={token => {
        if (props.onTokenSuccess) {
          props.onTokenSuccess();
        } else {
          updateTopNineOrder({
            method: "stripe",
            token: token.id,
          })
            .then(() => {
              setStatus("success");
              refreshCurrentUser();
            })
            .catch(() => {
              setStatus("error");
            });
        }
      }}
      paymentOnTokenSuccess={(token, method) => {
        if (props.onTokenSuccess) {
          props.onTokenSuccess();
        } else {
          updateTopNineOrder({
            method,
            token: token.id,
          })
            .then(() => {
              setStatus("success");
              refreshCurrentUser();
            })
            .catch(() => {
              setStatus("error");
            });
        }
      }}
      onClickButton={() => {
        setStatus("loading");
      }}
      onClickBuy={props.onClickBuy}
    />
  </InfoContainer>
);

const Text = styled.p`
  color: #6e788d;
  font-size: 15px !important;
  font-family: "Montserrat";
  font-weight: 500;
  text-align: left;
  @media (max-width: 640px) {
    font-size: 14px !important;
  }
  b {
    color: #f74255;
  }
`;

const CheckoutText = styled(Text)`
  margin-bottom: 16px;
`;
const LastText = styled(Text)`
  margin-bottom: 16px;
`;

const BuyFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const InfoContainer = styled.div`
  margin-top: 32px;
  @media (min-width: 640px) {
    ${BuyFormContainer} {
      display: none;
    }
    > ${LastText} {
      display: none;
    }
  }
  > ${LastText} {
    margin-top: 16px;
  }
`;

const ItemsContainer = styled.div`
  margin-bottom: 32px;
  @media (min-width: 640px) {
    display: flex;
    margin-bottom: 16px;
  }
`;

const Item = styled.div`
  display: flex;
  margin-bottom: 32px;
`;

const ItemContainer = styled.div`
  flex: 1;
  margin-left: 16px;
`;

const Title = styled.p`
  font-size: 14px !important;
  color: black;
  font-weight: bold;
  text-align: left;
  line-height: 1;
  margin-bottom: 4px !important;
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  object-position: center;
  margin-top: ${({ withMarginTop }) => (withMarginTop ? "-5px" : 0)};
`;

const DownloadBullets = styled.div`
  padding: 10px 0px 0px 20px;
`;

const DownloadBullet = styled.li`
  padding: 0;
  color: #6e788d;
  font-size: 15px !important;
  font-family: "Montserrat";
  font-weight: 600;
  text-align: left;
  @media (max-width: 640px) {
    font-size: 14px !important;
  }
  b {
    color: #f74255;
  }
`;

export default UnlockTopNineInfo;
